import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { createMigrate, persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'

import watchAll from '../sagas'
import initialState from './initialState'

import rootReducer from '../reducers'
import migrations from './migrations'

import { createBrowserHistory } from "history"
import Environment from '../utils/environment'

const blacklist = [
  'categories',
  'items',
  'stands',
  'menus',
  'revenueCenter',
  'cart',
  'orderTotalRemote',
  'refund',
  'search',
  'customer',
  'customerPayment',
  'orderingPreference',
  'printer',
  'receipt',
]

const persistConfig = {
  key: 'root',
  version: 9,
  storage,
  blacklist: ['attendant'],
  migrate: createMigrate(migrations, { debug: true })
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

function configureStore (initialState) {
  const sagaMiddleware = createSagaMiddleware()
  const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 })
  let middlewares = [sagaMiddleware]

  const middleware = composeEnhancers(
    applyMiddleware(...middlewares)
  )

  const store = createStore(
    persistedReducer,
    initialState,
    middleware,
  )

  const persistor = persistStore(store)

  sagaMiddleware.run(watchAll)

  return { store, persistor }
}

const { store, persistor } = configureStore(initialState)
const customHistory = createBrowserHistory()

if (!Environment.app.isProduction) {
  window.__VN_REDUX_STORE__ = store
}

export {
  store,
  persistor,
  customHistory,
}
